import React, { useCallback, useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { lessonRunsApi } from '../../../services/apiV2';

type ResolverStatus = 'loading' | 'error';

export const V2RunResolver: React.FC = () => {
  const { sectionId, planId } = useParams();
  const navigate = useNavigate();
  const [status, setStatus] = useState<ResolverStatus>('loading');

  const resolveRun = useCallback(async () => {
    if (!sectionId || !planId) {
      setStatus('error');
      return;
    }

    try {
      try {
        const activeRun = await lessonRunsApi.active(Number(sectionId));
        if (activeRun?.id) {
          navigate(`/v2/teacher/run/${activeRun.id}`, { replace: true });
          return;
        }
      } catch {
        // No active run; continue to start a new one.
      }

      const response = await lessonRunsApi.start({
        lesson_plan: Number(planId),
        section: Number(sectionId),
      });
      navigate(`/v2/teacher/run/${response.data.id}`, { replace: true });
    } catch {
      setStatus('error');
    }
  }, [navigate, planId, sectionId]);

  useEffect(() => {
    void resolveRun();
  }, [resolveRun]);

  if (status === 'error') {
    return (
      <div className="max-w-2xl mx-auto p-6 text-center">
        <div className="bg-white rounded-lg border border-gray-200 p-8">
          <h1 className="text-xl font-semibold text-gray-900 mb-2">Unable to start lesson run</h1>
          <p className="text-gray-600 mb-6">Please return to the Teach tab and try again.</p>
          <button
            className="px-6 py-2 bg-indigo-600 text-white rounded hover:bg-indigo-700"
            onClick={() => navigate('/v2/teacher')}
          >
            Back to Teach
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="max-w-2xl mx-auto p-6 text-center">
      <p className="text-gray-600">Starting lesson…</p>
    </div>
  );
};
